import "./libs/gsap-ease";
import "./libs/document-register-element";
import "./modules/helpers";
import domReady from "./modules/domReady";
import dispatcher from "./modules/dispatcher";
import domStore from "./modules/page-load/dom-ready.store";
import preloaderSimple from "./modules/page-load/preloader-simple.view";
import scrollTrigger from "./modules/trigger/scroll-trigger.view";
import simpleParallax from "./modules/parallax/simple-parallax.view";
import firstScroll from "./modules/scroll/first-scroll.view";
import headerHelper from "./modules/helpers/header-helper.view";
import { distComponents, matchComponent } from "./helpers/helpers";

import "./modules/touch/touch.view";
import "./modules/events/keyboard.view";
import "./modules/accessibility/outliner.view";
import "./modules/addressbar/addressbar.view";

import "./modules/scroll/scroll-locker-css.view";
import "./modules/scroll/synth-scroll.view";
import "./modules/scroll/end-scroll.view";

import "./modules/color/color.view";
import "./modules/content/content-hide.view";
import "./modules/router/router.view";

import "./modules/router/page-transition.component";
import "./modules/page/page-helper.component";
import "./modules/helpers/color-helper.component";

import "./modules/main-header/main-header.component";
import "./modules/img-background/img-background.component";

import "./modules/scroll/anchor.component";
import "./modules/router/inner-link.component";
import "./modules/share/share-link.component";
import "./modules/logo/logo-link.component";

import "./modules/cursor/cursor.component";

import "./modules/inputs/simple-select.component";
import "./modules/inputs/simple-input.component";
import "./modules/inputs/file-input.component";

import "./modules/tab/tab-wrapper.component";
import "./modules/tab/tab-switch.component";
import "./modules/tab/tab-scroll.component";

import "./modules/various/tag-wrapper.component";
import "./modules/various/indicator.component";
import "./modules/various/job-button.component";
import "./modules/various/ico.component";
import "./modules/various/team.component";
import "./modules/various/specialist-button.component";

import "./modules/map/map.component";
import "./modules/map/map-overlay.component";
import "./modules/map/contacts-link.component";

import "./modules/report/report-slide.component";
import "./modules/report/report-controls.component";
import "./modules/report/report.component";

import "./modules/filters/filter-reset.component";

import "./modules/switch/switch.component";

import "./modules/form/validateRequired";
import "./modules/cookieBanner/cookie-banner";

distComponents(() => {
  // import(/* webpackPrefetch: true */ './libs/gsap-ease');

  matchComponent("filters-component") &&
    import("./modules/filters/filters.component");
  matchComponent("filter-item") &&
    import("./modules/filters/filter-item.component");
  matchComponent("filter-reset") &&
    import("./modules/filters/filter-reset.component");
  matchComponent("pagination-component") &&
    import("./modules/filters/pagination.component");

  matchComponent("slider-component") &&
    import("./modules/slider/slider.component");
  matchComponent("slider-control") &&
    import("./modules/slider/slider-control.component");
  matchComponent("slider-control-group") &&
    import("./modules/slider/slider-control-group.component");
  matchComponent("slider-hover-group") &&
    import("./modules/slider/slider-hover-group.component");
  matchComponent("carousel-slider") &&
    import("./modules/slider/carousel-slider.component");
  matchComponent("text-slider") &&
    import("./modules/slider/text-slider.component");
  matchComponent("ico-slider") &&
    import("./modules/slider/ico-slider.component");

  matchComponent("slide-scroll") &&
    import("./modules/slide-scroll/slide-scroll.component");
  matchComponent("s-control") &&
    import("./modules/slide-scroll/slide-scroll-control.component");
}, 0);

distComponents(() => {
  import("./modules/form/form.component");
  import("./modules/form/form-response.component");
  import("./modules/form/input-wrapper.component");

  import(/* webpackPrefetch: true */ "./modules/stage/main-stage.component");

  if (!Modernizr.mobile && !Modernizr.touchevents) {
    import(
      /* webpackPrefetch: true */ "./modules/stage/object-stage.component"
    );
  }
}, 0);

// distComponents(() => {
//     import('./modules/menu/menu-button.component');
//     import('./modules/round-button/round-button.component');
//
//     if (!Modernizr.mobile && !Modernizr.touchevents) {
//         import('./modules/hover/hover-block.component');
//     }
// }, 0);

distComponents(() => {
  import("./modules/form/form.component");
  import("./modules/form/form-response.component");
  import("./modules/form/input-wrapper.component");

  import("./modules/popup/popup.component");
  import("./modules/popup/popup-close.component");
  import("./modules/popup/popup-helper.view");
  import("./modules/popup/popup-toggle.component");
  import("./modules/popup/popup-overlay.component");
}, 0);

domReady(function () {
  dispatcher.dispatch({
    type: "dom:ready",
  });

  preloaderSimple.init();
  scrollTrigger.init();
  simpleParallax.init();
  firstScroll.init();
  headerHelper.init();

  /*
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js');
    }

     */
});

let pw = document.getElementsByClassName("page-wrapper")[0];

setTimeout(() => {
  pw.classList.add("instant-load");
}, 100);
